import { createSelector } from '@reduxjs/toolkit'
import { NotificationsState } from 'sierra-client/state/notifications/types'
import { RootState } from 'sierra-client/state/types'

const selectState = (state: RootState): NotificationsState => state.notifications

export const selectNotificationErrors = createSelector(selectState, state => state.errors)

export const selectNotifications = createSelector(selectState, state => state.notifications)
